import { Controller } from "stimulus"
import Handlebars from 'handlebars'

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const $ = window.jQuery
    const Bloodhound = window.Bloodhound
    const host = window.location.hostname
    const protocol = window.location.protocol
    const port = window.location.port
    const $input = $(this.inputTarget)

    const communities = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        prepare: (query, settings) => {
          settings.url = settings.url + '?q=' + query
          return settings
        },
        url: '/partner/api/communities.json',
        wildcard: '%QUERYSTRING',
        filter: (data) => {
          return $.map(data.communities, (community) => {
            return {
              name: community.name,
              subdomain: community.subdomain,
              address: community.address
            }
          })
        }
      }
    })

    $input.typeahead({ minLength: 3 }, {
      name: 'community-select',
      display: 'name',
      limit: 10,
      source: communities,
      templates: {
        suggestion: Handlebars.compile(`
          <div>
            <h4>{{name}}</h4>
            <p>{{address}}</p>
          </div>
        `),
        notFound: ['<div class="tt-no-results">No Results</div>']
      }
    }).bind('typeahead:selected', (event, obj) => {
      const url = protocol + '//' + obj.subdomain + '.' + host + ':' + port
      window.location.href = url
    })

    $input.on('keypress', (e) => {
      if (e.which === 13) {
        $('.tt-suggestion:first-child').trigger('click')
        return false
      }
    })
  }

  disconnect() {
    const $ = window.jQuery
    if (this.hasInputTarget) {
      $(this.inputTarget).typeahead('destroy')
    }
  }
}
